<div class="panel">
  <h1>{{'USERS.Title' | translate}}</h1>
  <div class="container">

      <div class="row">
          <div class="col-md-12 offset-md-3">
            <label style="font-weight: bold;">{{'USERS.ThirdPartyUser' | translate}}:</label><br>
            <p-toggleswitch [(ngModel)]="isNew3rdParty"  (click)="toggleUserType()"></p-toggleswitch>
          </div>
        </div>

    <div class="row" style="margin-bottom: 1em" *ngIf="!isNew3rdParty">
      <div class="col-sm-8 offset-sm-3">
        <h3 style="text-align:left"><i class="pi pi-search"></i>{{'USERS.AddNewUser' | translate}}</h3>
        <p-autoComplete (completeMethod)="searchDirectoryUsers($event)" (onSelect)="fillInfo($event)" [suggestions]="directoryUsers"
          [dropdown]="true" [virtualScroll]="true" [virtualScrollItemSize]="34" [size]="63" placeholder="{{'USERS.Type' | translate}}" optionLabel="Email" [minLength]="2"
          [(ngModel)]="selectedUser">
          <ng-template let-u #item>
            <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
              <div><i class="pi pi-user"></i> {{u.FirstName}} {{u.LastName}} ({{u.Email}})</div>
            </div>
          </ng-template>
        </p-autoComplete>
      </div>
    </div>

    <div class="row" style="margin-bottom: 1em" *ngIf="isNew3rdParty">
      <div class="col-sm-6 col-md-6 col-lg-5 offset-sm-3">
        <h3 style="text-align:left"><i class="pi pi-search"></i>{{'USERS.AddNewUser' | translate}}</h3>
        <input type="text" pInputText class="form-control" readonly>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 offset-sm-3">
        <label>{{'USERS.FirstName' | translate}}:</label>
        <input type="text" pInputText [(ngModel)]="FirstName" class="form-control" [readonly]="!isNew3rdParty">
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 offset-sm-3">
        <label>{{'USERS.LastName' | translate}}:</label>
        <input type="text" pInputText [(ngModel)]="LastName" class="form-control" [readonly]="!isNew3rdParty">
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 offset-sm-3">
        <label>{{'USERS.EmailAddress' | translate}}:</label>
        <input type="email" pInputText [(ngModel)]="EmailAddress" class="form-control" [readonly]="!isNew3rdParty">

        <div *ngIf="isNew3rdParty" class="alert alert-warning">{{'USERS.EnsureEmail' | translate}}</div>
      </div>

    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="btn-container labeled right">
          <div style="display: flex; justify-content: flex-end;">
            <p-button label="{{'USERS.SaveUser' | translate}}" icon="pi pi-check" styleClass="ui-button-primary" (click)="saveUser()"></p-button>
          </div>
        </div>        
      </div>
    </div>
  </div>
</div>
<!-- <hr> -->
<div class="panel">
  <div class="container">    
    <p-tabs value="0" (valueChange)="activeInActiveUserstabChanged($event)" class="custom-tabview">
      <p-tablist>
        <p-tab value="0">Active Users</p-tab>
        <p-tab value="1" *ngIf="isAdmin">Disabled Users</p-tab>
      </p-tablist>
      <p-tabpanels>
      <p-tabpanel value="0">
    <p-table #tt [value]="activeUsers" showGridlines [(first)]="firstPage" [paginator]="true" [rows]="10" [globalFilterFields]="['FirstName','LastName','Email']">
      <ng-template pTemplate="caption">
        <div class="row">
          <div class="col-sm-6">            
            <input type="text" pInputText placeholder="{{'USERS.Filter' | translate}}" (input)="tt.filterGlobal($event.target.value, 'contains')"
              class="form-control">           
          </div>
          <div class="col-sm-4"></div>
          <div class="col-sm-2">
            <p-select [options]="dropdownOptions"
            [(ngModel)]="selectedAUOption" 
            optionLabel="name"
            (onChange)="filterActiveUsersonRoleSelect($event)">
            </p-select>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" pSortableColumn="FirstName">{{'USERS.FirstName' | translate}}<p-sortIcon field="FirstName"></p-sortIcon>
          </th>
          <th scope="col" pSortableColumn="LastName">{{'USERS.LastName' | translate}}<p-sortIcon field="LastName"></p-sortIcon>
          </th>
          <th scope="col" pSortableColumn="Email" style="width: 300;">{{'USERS.Email' | translate}}<p-sortIcon field="Email"></p-sortIcon>
          </th>          
          <th scope="col" pSortableColumn="sysAdmin" style="width: 110;">{{'USERS.SystemAdmin' | translate}}?<p-sortIcon field="sysAdmin"></p-sortIcon>
          </th>
          <th scope="col" style="width: 110;">{{'USERS.Enabled' | translate}}</th>         
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr>
          <td>{{user.FirstName}}</td>
          <td>{{user.LastName}}</td>
          <td>{{user.Email}}</td>          
          <td>
            <div *ngIf="isAdmin">
              <p-toggleswitch [(ngModel)]="user.sysAdmin" (click)="updateUser(user)"></p-toggleswitch>
            </div>
            <div *ngIf="!isAdmin">
              <div *ngIf="user.sysAdmin">
                <i class="pi pi-check"></i>
              </div>
            </div>
          </td>
          <td>
            <div *ngIf="isAdmin">
              <p-toggleswitch [(ngModel)]="user.IsActive" (ngModelChange)="toggleUserStatus(user, $event)"></p-toggleswitch>
            </div>
            <div *ngIf="!isAdmin">
              <i *ngIf="user.IsActive" class="pi pi-check"></i>
            </div>
          </td>
          
        </tr>
      </ng-template>
    </p-table>
  </p-tabpanel>
  <p-tabpanel value="1" *ngIf="isAdmin">
    <p-table #tt [value]="inactiveUsers" showGridlines [(first)]="firstPage" [paginator]="true" [rows]="10" [globalFilterFields]="['FirstName','LastName','Email']">
      <ng-template pTemplate="caption">
        <div class="row">
          <div class="col-sm-6">
            <input type="text" pInputText placeholder="{{'USERS.Filter' | translate}}" (input)="tt.filterGlobal($event.target.value, 'contains')"
              class="form-control">
          </div>
          <div class="col-sm-4"></div>
          <div class="col-sm-2">
            <p-select [options]="dropdownOptions"
            [(ngModel)]="selectedDUOption" 
            optionLabel="name"
            (onChange)="filterInActiveUsersonRoleSelect($event)">
            </p-select>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" pSortableColumn="FirstName">{{'USERS.FirstName' | translate}}<p-sortIcon field="FirstName"></p-sortIcon>
          </th>
          <th scope="col" pSortableColumn="LastName">{{'USERS.LastName' | translate}}<p-sortIcon field="LastName"></p-sortIcon>
          </th>
          <th scope="col" pSortableColumn="Email" style="width: 300;">{{'USERS.Email' | translate}}<p-sortIcon field="Email"></p-sortIcon>
          </th>     
          <th scope="col" pSortableColumn="sysAdmin" style="width: 110;">{{'USERS.SystemAdmin' | translate}}?<p-sortIcon field="sysAdmin"></p-sortIcon>
          </th>
          <th scope="col" style="width: 110;">{{'USERS.Enabled' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr>
          <td>{{user.FirstName}}</td>
          <td>{{user.LastName}}</td>
          <td>{{user.Email}}</td>         
          <td>
            <div *ngIf="isAdmin">
              <p-toggleswitch [(ngModel)]="user.sysAdmin" (click)="updateUser(user)"></p-toggleswitch>
            </div>
            <div *ngIf="!isAdmin">
              <div *ngIf="user.sysAdmin">
                <i class="pi pi-check"></i>
              </div>
            </div>
          </td>
          <td>
            <div *ngIf="isAdmin">
              <p-toggleswitch [(ngModel)]="user.IsActive" (ngModelChange)="toggleUserStatus(user, $event)"></p-toggleswitch>
            </div>
            <div *ngIf="!isAdmin">
              <i *ngIf="user.IsActive" class="pi pi-check"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabpanel>
  </p-tabpanels>
  </p-tabs>
  </div>
</div>
